import { createContext } from 'react';
export function createSSRManager() {
  var promiseSet = new Set();
  return {
    hasPromises: function hasPromises() {
      return promiseSet.size > 0;
    },
    register: function register(promise) {
      promiseSet.add(promise);
    },
    consumeAndAwaitPromises: function consumeAndAwaitPromises() {
      var promises = Array.from(promiseSet);
      promiseSet.clear();
      return Promise.all(promises);
    }
  };
}
export var SSRContext = createContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-apollo-hooks/es/internal/SSRContext.js
// module id = 190
// module chunks = 0